import { createTheme } from '@mui/material/styles';
import shippoTheme from '../styles/shippoTheme.js';
import { tabsThemeInput } from '../Tabs/Tabs.theme.js';
import { deepmerge } from '@mui/utils';

function extendedTabsTheme(themeExtension) {
    if (!themeExtension) {
        return createTheme(shippoTheme, tabsThemeInput);
    }
    const extendedTabsTheme = {
        components: {
            MuiTabs: {
                styleOverrides: {
                    root: Object.assign({}, themeExtension),
                },
            },
        },
    };
    return createTheme(shippoTheme, deepmerge(tabsThemeInput, extendedTabsTheme));
}

export { extendedTabsTheme };
//# sourceMappingURL=tabsThemeExtension.js.map
